import React from 'react';

/**
 * Reusable search + sort toolbar for detail pages (SO, SE, PE, PO, SR, PR).
 */
const DetailSearchSort = ({ search, setSearch, sortBy, setSortBy, sortOptions, testIdPrefix = 'detail' }) => (
  <div className="px-4 py-2 border-b bg-gray-50 flex items-center gap-3 flex-wrap">
    <input
      type="text"
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      placeholder="Search design code..."
      className="h-8 w-48 px-3 text-sm border border-gray-300 rounded-md focus:outline-none focus:border-blue-500"
      data-testid={`${testIdPrefix}-search`}
    />
    <select
      value={sortBy}
      onChange={(e) => setSortBy(e.target.value)}
      className="h-8 px-2 text-xs border border-gray-300 rounded-md focus:outline-none"
      data-testid={`${testIdPrefix}-sort`}
    >
      <option value="">Default Order</option>
      <option value="design_asc">Design A→Z</option>
      <option value="design_desc">Design Z→A</option>
      <option value="qty_desc">Qty High→Low</option>
      <option value="qty_asc">Qty Low→High</option>
      {sortOptions?.includes('rate') && <option value="rate_desc">Rate High→Low</option>}
      {sortOptions?.includes('amount') && <option value="amount_desc">Amount High→Low</option>}
      <option value="color_asc">Colour A→Z</option>
    </select>
  </div>
);

/**
 * Apply search and sort to rows array.
 * rows: array of {item: {design_code, ...}, color, qty, amount, rate, ...}
 */
export function filterAndSortRows(rows, search, sortBy) {
  let list = rows;
  if (search) {
    const q = search.toLowerCase();
    list = list.filter(r => r.item?.design_code?.toLowerCase().includes(q));
  }
  if (sortBy) {
    list = [...list].sort((a, b) => {
      switch (sortBy) {
        case 'design_asc': return (a.item?.design_code || '').localeCompare(b.item?.design_code || '', undefined, { numeric: true });
        case 'design_desc': return (b.item?.design_code || '').localeCompare(a.item?.design_code || '', undefined, { numeric: true });
        case 'qty_desc': return (b.qty || 0) - (a.qty || 0);
        case 'qty_asc': return (a.qty || 0) - (b.qty || 0);
        case 'rate_desc': return (b.rate || 0) - (a.rate || 0);
        case 'amount_desc': return (b.amount || 0) - (a.amount || 0);
        case 'color_asc': return (a.color || '').localeCompare(b.color || '');
        default: return 0;
      }
    });
  }
  return list;
}

export default DetailSearchSort;
